import React from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import Textfield from "../../../profile/GuestLoginForm/components/TextField";
import { Button, Grid } from "@mui/material";
import {editDueAmount} from "../../../../redux/actions/RatActions"
import { useDispatch,useSelector } from "react-redux";
const FORM_VALIDATION = Yup.object().shape({
    dueAmount: Yup.number().required("Required"),
});



const EditDueAmount = (props) => {
  const INITIAL_FORM_STATE = {
    dueAmount: props.guestdetails.dueAmount,
  };
  const editDue = useSelector((state)=>state.buildings.editDue)
    const dispatch=useDispatch()
  return (
    <div>
      {" "}
      <Formik
        initialValues={{ ...INITIAL_FORM_STATE }}
        validationSchema={FORM_VALIDATION}
        onSubmit={amount => {
          dispatch(editDueAmount(props.guestdetails.id,amount))
          props.editGuestHandler();
          console.log(editDue)
          props.handleCloseGuestModalWindow()
        }}
      >
        {(formProps) => (
          <Form>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <h6>Amount Paid *</h6>
                <Textfield name="dueAmount" required />
              </Grid>
              <Grid item xs={3} sx={{ paddingBottom: 3 }}>
              <Button type="submit">Submit</Button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default EditDueAmount;
